import { render, staticRenderFns } from "./TransferUpload.vue?vue&type=template&id=33c79016"
import script from "./TransferUpload.vue?vue&type=script&lang=js"
export * from "./TransferUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports